import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = ({ onWhatsAppClick }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/10 via-background to-accent/5 py-16 lg:py-24">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23B8860B%22%20fill-opacity%3D%220.05%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-30"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Crown Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="w-20 h-20 bg-gradient-royal rounded-full flex items-center justify-center shadow-royal animate-float">
                <Icon name="Crown" size={40} color="white" strokeWidth={2} />
              </div>
              <div className="absolute -top-2 -right-2 w-6 h-6 bg-accent rounded-full flex items-center justify-center animate-pulse-golden">
                <Icon name="MessageCircle" size={14} color="white" strokeWidth={2.5} />
              </div>
            </div>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl lg:text-6xl font-heading font-bold text-gradient-royal mb-6">
            VIP Contact Suite
          </h1>
          
          <p className="text-xl lg:text-2xl text-text-secondary mb-4 font-body">
            Connect with India's Premier Gaming Experts
          </p>
          
          <p className="text-lg text-text-muted mb-8 max-w-2xl mx-auto leading-relaxed">
            Experience personalized gaming consultation through WhatsApp. Our expert advisors are available 24/7 to guide you through premium gaming experiences with instant responses and exclusive offers.
          </p>

          {/* Primary WhatsApp CTA */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button
              variant="default"
              size="lg"
              onClick={onWhatsAppClick}
              iconName="MessageCircle"
              iconPosition="left"
              className="bg-gradient-royal hover:shadow-glow animate-pulse-golden hover:animate-none text-lg px-8 py-4"
            >
              Connect with Gaming Expert
            </Button>
            
            <div className="flex items-center space-x-2 text-text-secondary">
              <div className="w-3 h-3 bg-success rounded-full animate-pulse"></div>
              <span className="text-sm font-medium">Online Now • Avg Response: 2 mins</span>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex items-center justify-center space-x-3 p-4 bg-surface rounded-card shadow-subtle">
              <Icon name="Shield" size={24} color="var(--color-success)" />
              <div className="text-left">
                <p className="font-semibold text-text-primary">100% Secure</p>
                <p className="text-sm text-text-muted">End-to-end encryption</p>
              </div>
            </div>
            
            <div className="flex items-center justify-center space-x-3 p-4 bg-surface rounded-card shadow-subtle">
              <Icon name="Clock" size={24} color="var(--color-primary)" />
              <div className="text-left">
                <p className="font-semibold text-text-primary">24/7 Support</p>
                <p className="text-sm text-text-muted">Always available</p>
              </div>
            </div>
            
            <div className="flex items-center justify-center space-x-3 p-4 bg-surface rounded-card shadow-subtle">
              <Icon name="Users" size={24} color="var(--color-accent)" />
              <div className="text-left">
                <p className="font-semibold text-text-primary">10K+ Players</p>
                <p className="text-sm text-text-muted">Trust our service</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;